import type { icons } from 'src/components/ui/Icon';

export type PublisherDetails = { name: string; logo?: keyof typeof icons };
export const realEstateSources: Record<string, PublisherDetails> = {
    AVendreALouer: { name: 'AVendreALouer', logo: 'AVendreALouer' },
    Axo: { name: 'AXO - L’Immobilier Actif', logo: 'Axo' },
    'Belles Demeures': { name: 'Belles Demeures', logo: 'BellesDemeures' },
    Bienici: { name: 'Bien’ici', logo: 'BienIci' },
    Century21: { name: 'Century 21', logo: 'Century21' },
    'Connexion Immobilier': { name: 'Connexion Immobilier', logo: 'ConnexionImmobilier' },
    'Consultants Immobilier': { name: 'CONSULTANTS IMMOBILIER', logo: 'ConsultantsImmobilier' },
    DB: { name: 'Autre source', logo: undefined },
    DrHouse: { name: 'Dr House Immo', logo: 'DrHouseImmo' },
    Era: { name: 'ERA Immobilier', logo: 'EraImmobilier' },
    EtreProprio: { name: 'EtreProprio', logo: 'EtreProprio' },
    Foncia: { name: 'Foncia', logo: 'Foncia' },
    GDC: { name: 'Gens de confiance', logo: 'GensDeConfiance' },
    Hosman: { name: 'Hosman', logo: 'Hosman' },
    IAD: { name: 'IAD', logo: 'IAD' },
    Immoregion: { name: 'immoRegion', logo: 'ImmoRegion' },
    kwFrance: { name: 'Keller Williams France', logo: 'KellerWilliamsFrance' },
    Ladresse: { name: 'l’Adresse Immobilier', logo: 'LAdresseImmobilier' },
    Laforet: { name: 'Laforêt', logo: 'LaForet' },
    'Gens de confiance': { name: 'Gens de confiance', logo: 'GensDeConfiance' },
    LBC: { name: 'Leboncoin', logo: 'LeBonCoin' },
    'Le Figaro': { name: 'Figaro Immobilier', logo: 'FigaroImmobilier' },
    'Les Abriculteurs': { name: 'Abriculteurs', logo: 'Abriculteurs' },
    'Lux-Residence': { name: 'Lux Residence', logo: 'LuxResidence' },
    'L-Immo': { name: 'Logic-Immo', logo: 'LogicImmo' },
    ORPI: { name: 'Orpi', logo: 'OrpiLogo' },
    ParuVendu: { name: 'ParuVendu', logo: 'ParuVendu' },
    SAFTI: { name: 'SAFTI', logo: 'Safti' },
    SL: { name: 'SeLoger', logo: 'SeLoger' },
    SeLoger: { name: 'SeLoger', logo: 'SeLoger' },
    'Stephane Plaza': { name: 'Stéphane Plaza Immobilier', logo: 'StephanePlazaImmobilier' },
    Superimmo: { name: 'Superimmo', logo: 'Superimmo' },
    "Sotheby's": { name: "Sotheby's", logo: 'Sotheby' },
    PAP: { name: 'PAP', logo: 'Pap' },
    'Green-Acres': { name: 'Green-Acres', logo: 'GreenAcres' },
    'Propriétés Le Figaro': { name: 'Propriétés Le Figaro', logo: 'ProprieteLeFigaro' },
    Licitor: { name: 'Licitor', logo: 'Licitor' },
};
